export const SITE_KEY = '6LejwKAUAAAAACs5B-wV9ndjxrE49x3lGztPznl_';
export const ENTERPRISE_SITE_KEY = '6Ld0J8IcAAAAANyrnxzrRlX1xrrdXsOmsepUYosy';
